"use strict";

var generateHelpUrl = require('@sanity/generate-help-url');
var urlBuilder = require('@sanity/image-url');
var objectAssign = require('object-assign');
var enc = encodeURIComponent;
var materializeError = "You must either:\n  - Pass `projectId` and `dataset` to the block renderer\n  - Materialize images to include the `url` field.\n\nFor more information, see ".concat(generateHelpUrl('block-content-image-materializing'));
var getQueryString = function getQueryString(options) {
  var query = options.imageOptions;
  var keys = Object.keys(query);
  if (!keys.length) {
    return '';
  }
  var params = keys.map(function (key) {
    return "".concat(enc(key), "=").concat(enc(query[key]));
  });
  return "?".concat(params.join('&'));
};
var buildUrl = function buildUrl(props) {
  var node = props.node,
    options = props.options;
  var projectId = options.projectId,
    dataset = options.dataset;
  var asset = node.asset;
  if (!asset) {
    throw new Error('Image does not have required `asset` property');
  }
  if (asset.url) {
    return asset.url + getQueryString(options);
  }
  if (!projectId || !dataset) {
    throw new Error(materializeError);
  }
  var ref = asset._ref;
  if (!ref) {
    throw new Error('Invalid image reference in block, no `_ref` found on `asset`');
  }
  return urlBuilder(objectAssign({
    projectId: projectId,
    dataset: dataset
  }, options.imageOptions || {})).image(node).toString();
};
module.exports = buildUrl;